import { ReactComponent as FooterLogo } from '../../../assets/svg/logo/main.svg'
import styles from './Footer.module.css'

// Spec §2 — "Powered by" + Paga logo on the left, "Help · Privacy" on the right. No
// destinations are specified anywhere in the spec/codebase for Help/Privacy yet, so they're
// plain text for now rather than links that would silently go nowhere.
const Footer = () => (
  <div className={styles.footer}>
    <div className={styles.poweredBy}>
      <span>Powered by</span>
      <FooterLogo className={styles.logo} />
    </div>
    <div className={styles.links}>
      <span>Help</span>
      <span className={styles.dot} aria-hidden='true' />
      <span>Privacy</span>
    </div>
  </div>
)

export default Footer
